import { useAuth } from 'hooks/useAuth';
import { useEffect } from 'react';
import { useRouter } from 'next/router';

export const useRequireAuth = (redirectUrl = '/login') => {
  const auth = useAuth();
  const router = useRouter();

  // If auth.user is false that means we're not
  // logged in and should redirect.
  useEffect(() => {
    const timed = setTimeout(() => {
      if (!auth.user) {
        router.push(`${redirectUrl}?returnTo=${router.asPath}`);
      }
    }, 300);
    return () => clearTimeout(timed);
  }, [auth, redirectUrl, router]);

  return auth;
};
